import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, EmployeeId, EmployeeCode, Company } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { encryption } from '../../../utils/encryption';

export function getProfileList() {
    let url = 'profile/GetProfileList?' + objectToQueryString({ userCode: encryption(UserCode()), EmployeeId: encryption(EmployeeId()), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.list);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}


export function getPendingProfileList() {
    let url = 'profile/GetPendingProfileList?' + objectToQueryString({ userCode: encryption(UserCode()), EmployeeId: encryption(EmployeeId()), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.list);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getProvince() {
    let url = 'profile/GetProvince?' + objectToQueryString({ userCode: encryption(UserCode()), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.list);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function deletePendingProfile(employeeModificationId) {
    return fetch('profile/DeletePendingProfile', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            employeeChangeIdCrypt: encryption(employeeModificationId),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function saveAddressProfile(employeeModificationId, effectiveDate, immediateChange, address1, address2, city, province, postalCode, personalPhone, personalCellphone, personalEmail, comment) {
    return fetch('profile/SaveAddressProfile', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            employeeCodeCrypt: encryption(EmployeeCode()),
            employeeIdCrypt: encryption(EmployeeId()),
            companyCrypt: encryption(Company()),
            emplChangIdCrypt: encryption(employeeModificationId),

            effectiveDate: effectiveDate,
            address1: address1,
            address2: address2,
            city: city,
            province: province,
            postalCode: postalCode,
            personalPhone: personalPhone,
            personalCellphone: personalCellphone,
            personalEmail: personalEmail,
            comment: comment,
            immediateChange: immediateChange,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getInfoEmployee() {
    let url = 'profile/GetInfoEmployee?' + objectToQueryString({ userCode: encryption(UserCode()), employeeId: encryption(EmployeeId()), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.list);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function saveAdditionalInformation(language, flagFullTime, availableFullTime, availability, region, isReserve, flagOnCall, onCall) {
    return fetch('profile/SaveAdditionalInformation', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            employeeIdCrypt: encryption(EmployeeId()),
            language: language,
            flagFullTime: flagFullTime,
            availableFullTime: availableFullTime,
            availability: availability,
            region: region,
            isReserve: isReserve,
            flagOnCall: flagOnCall,
            onCall: onCall,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function saveMedical(handicap, allergie, conditionMedicalSection, isConditionMedicalSectionConfidential, otherMedicalSection, isOtherMedicalSectionConfidential) {
    return fetch('profile/SaveMedical', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            employeeIdCrypt: encryption(EmployeeId()),
            handicap: handicap,
            allergie: allergie,
            conditionMedicalSection: conditionMedicalSection,
            isConditionMedicalSectionConfidential: isConditionMedicalSectionConfidential,
            otherMedicalSection: otherMedicalSection,
            isOtherMedicalSectionConfidential: isOtherMedicalSectionConfidential,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function loadAdditionalCombos() {
    let url = 'profile/additionalCombos?' + objectToQueryString(
        {
            company: Company(),
            userCodeCrypt: encryption(UserCode()),
            token: Token()
        });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
    .then(checkHttpStatus)
    .then(expiredToken)
    .then(parseJSON)
    .then(response => {
        try {
            return response;
        } catch (e) {
            errorResponse(response);
        }
    })
    .catch(error => {
        errorResponse(error);
    })
}
export function sortRegionsByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.jobCode
        const nameB = b.jobCode
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}